import { BASE, LIGHT, SIGNAL, STROKE } from './palette';

/**
 * 渲染层的**用法层**：字体 + 按用途取色。
 *
 * 颜色的**定义**在 `palette.ts`，这里只是把它翻译成"界面代码会问的那些问题"
 * （底色用什么、正文用什么、强调用什么）。分成两个文件是因为：
 * 色板是设计资产（要能单独看、单独换），而这里是使用约定。
 *
 * ⚠️ 底色是**纯黑**（acid design）。所以：
 * - 文字用 `LIGHT.*`（白），不是深色
 * - 需要"跳出来"的用 `SIGNAL.*`（荧光原色）；细线和描边用 `STROKE.*`（收过饱和）
 * - 要抬起来的面板用 `BASE.raised`（近黑），**不要用亮色**，会破坏黑底
 */

/**
 * **字体角色。**
 *
 * ⚠️ 全项目**没有字体文件** —— 所以"风格"只能靠**字重对比、挖空、字距、
 * 机械斜切**做出来，不能靠换字形。这里给的只是"每种用途用哪个字体栈"。
 *
 * | 角色 | 用在哪 |
 * | --- | --- |
 * | `mono` | 版号、编号、档案行、寄存器 —— 一切**机器读的**东西 |
 * | `display` | 主标题、数字大字 —— 要**砸在脸上**的东西 |
 * | `cjk` | 中文牌名、规则正文 —— 只要求**读得快** |
 */
export const FONT_MONO =
  'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';
export const FONT_DISPLAY =
  'Impact, Haettenschweiler, "Arial Narrow Bold", "PingFang SC", "Noto Sans CJK SC", sans-serif';
export const FONT_CJK =
  '"PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif';

/** `FontRole` → 具体字体栈。 painter 用这张表 */
export const FONT_ROLE = {
  mono: FONT_MONO,
  display: FONT_DISPLAY,
  cjk: FONT_CJK,
} as const;

/** @deprecated 用 `FONT_MONO` / `FONT_CJK` / `FONT_DISPLAY`。保留只是为了不改旧调用点 */
export const FONT = FONT_MONO;

export const COLORS = {
  /** 大面积底色：纯黑 */
  background: BASE.void,
  /** 面板 / 卡片槽位底 */
  panel: BASE.raised,
  /** 分隔线、凹陷 */
  panelEdge: BASE.sunken,

  /** 黑底上的正文 */
  text: LIGHT.base,
  /** 黑底上的次要文字 */
  textDim: LIGHT.dim,
  /** 半调网点的白色 */
  ink: LIGHT.halftone,

  /** 荧光原色：发光、高亮 */
  accent: SIGNAL.accent,
  danger: SIGNAL.danger,
  warning: SIGNAL.warning,
  ok: SIGNAL.ok,
  info: SIGNAL.info,
  special: SIGNAL.special,

  /** 收过饱和的线条色：细线、描边 */
  line: STROKE.accent,
  lineDim: STROKE.neutral,
} as const;
